import * as api from './api';
import * as utils from './utils';
import * as tips from './tips';
import $ from 'jquery';
const level = [100000, 200000, 300000, 500000, 1000000];
export let nowCharIndex = 1; // 默认第一张
export const initPage = async (isFirst = false) => {
  const telephone = localStorage.getItem(api.TELEPHONE);
  const baseRes = await api.getBase();
  const reserveInfoRes = await api.getReserveInfo();
  telephone
    ? $('.j-user-info').html(`您好，${telephone}`).css('display', 'flex')
    : $('.j-user-info').hide();
  +baseRes.code && $('.j-count').html(baseRes.data.lotteryChance || 0);
  if (+reserveInfoRes.code) {
    const reserveTotal = reserveInfoRes.data.reserveTotal;
    $('.j-fixed-reserve-count,.j-reserve-count').html(reserveTotal || 0);
    for (let i = 0; i < 5; i++) {
      reserveTotal >= level[i] && $('.j-award-' + level[i]).addClass('active');
    }
  }

  // 初始化預約里程碑
  if (isFirst) {
    // 首次加載渲染swiper內容數據
    initSwiper();
    tips.initComment();
    /*sdk内打开隐藏下载按钮、官网入口*/
    if (utils.getParams('devicePlate')) {
      $('.j-appStore,.j-googlePlay,.j-offical-btn,.j-qrcode').hide();
    }
  }
};

const initSwiper = () => {
  const charList = [
    'hanli',
    'nangongwan',
    'yinyue',
    'guhuojin',
    'mojuren',
    'chenqiaoqian',
  ];
  const msgSwiper = new Swiper('.msgSwiper', {
    autoplay: true,
    loop: true,
    observer: true,
    observeParents: true,
  });

  const charSwiper = new Swiper('.j-char-container', {
    loop: true,
    observer: true,
    observeParents: true,
    speed: 800,
    on: {
      slideChange: function () {
        let pre = this.previousIndex === 7 ? 1 : this.previousIndex || 6;
        nowCharIndex = this.activeIndex === 7 ? 1 : this.activeIndex || 6;
        $(`.j-char-introduction .char-text:nth-child(${pre})`)
          .fadeOut(800)
          .removeClass('active activeFast');
        $(`.j-char-introduction .char-text:nth-child(${nowCharIndex})`)
          .show()
          .removeClass('active activeFast')
          .addClass('activeFast');
        // 修改移动端切换按钮头像
        $('.j-prev-btn-mobile')
          .removeClass(charList.join(' '))
          .addClass(charList[nowCharIndex === 1 ? 5 : nowCharIndex - 2]);
        $('.j-next-btn-mobile')
          .removeClass(charList.join(' '))
          .addClass(charList[nowCharIndex === 6 ? 0 : nowCharIndex]);
      },
    },
    navigation: {
      nextEl: '.j-char-next-btn',
      prevEl: '.j-char-prev-btn',
    },
    pagination: {
      el: '.j-char-choose',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="char-name swiper-pagination-bullet j-collect ${
            i + 1 == current
              ? 'swiper-pagination-bullet-active char-name-active'
              : ''
          } ${charList[i]}" data-index="${i}" data-collect="${
            charList[i]
          }"></a>`;
        }
        return html;
      },
    },
  });
  const specialSwiper = new Swiper('.j-special-container', {
    loop: true,
    autoplay: true,
    effect: 'coverflow',
    observer: true,
    observeParents: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    coverflowEffect: {
      rotate: 30,
      stretch: 10,
      depth: 60,
      modifier: 2,
      slideShadows: false,
    },
    pagination: {
      el: '.j-special-pagination',
      bulletClass: 'special-point',
      bulletActiveClass: 'special-point-active',
      clickable: true,
    },
    navigation: {
      nextEl: '.j-special-navigation-next',
      prevEl: '.j-special-navigation-prev',
    },
  });
};
